import { StyledUnlockButton } from "../styled_components/StyledUnlockButton"
import React from 'react';


const UnlockButton = ({lock, handler}) => {
    return (
        <StyledUnlockButton lock = {lock} onClick = {handler}>
            <div id = "anilla"><div id = "smaller"></div></div>
        </StyledUnlockButton>
    )
}

export default UnlockButton;